import React from "react";
import { Controller } from "react-hook-form";
import { InputNumber } from "primereact/inputnumber";

const NumberField = ({
  name,
  control,
  label,
  unit,
  placeholder,
  rules,
  errors,
  mode,
  suffix,
  minFractionDigits = 1,
  maxFractionDigits = 1,
  defaultValue = "",
  helpText = "",
}) => {
  return (
    <div className="field">
      <label htmlFor={name} className="block">
        {label}
        {unit && <span className="text-xs">({unit})</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => (
          <>
            <InputNumber
              value={field.value}
              onValueChange={(e) => field.onChange(e.value)}
              className={`${
                fieldState.invalid ? "p-invalid" : ""
              } p-inputtext-sm w-full`}
              placeholder={placeholder}
              mode={mode}
              suffix={suffix}
              minFractionDigits={minFractionDigits}
              maxFractionDigits={maxFractionDigits}
            />
            {helpText?.length > 0 && (
              <small className="block text-xs">{helpText}</small>
            )}
            {errors[name] && (
              <small className="p-error block">{errors[name].message}</small>
            )}
          </>
        )}
      />
    </div>
  );
};

export default NumberField;
